import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFireFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.75 14.566q0-2.71 1.289-4.96 1.29-2.254 2.836-3.892 1.546-1.64 2.836-2.552L12 2.25v3.393q0 .855.601 1.453.602.6 1.49.6.487 0 .873-.2.387-.2.702-.57l.459-.57Q17.93 7.38 19.104 9.69a10.3 10.3 0 0 1 1.145 4.846q-.028 2.224-1.074 4.063t-2.936 2.979q.459-.656.688-1.397.228-.742.229-1.51 0-.941-.33-1.826a4.8 4.8 0 0 0-.988-1.596L12 10.974 8.16 15.25a4.8 4.8 0 0 0-.988 1.596q-.33.885-.33 1.825 0 .798.244 1.554.244.755.73 1.411a8.16 8.16 0 0 1-2.979-2.994 8 8 0 0 1-1.088-4.076m8.25-.513 2.291 2.565q.401.428.602.956.2.527.2 1.097 0 1.283-.902 2.181-.903.898-2.191.898-1.29 0-2.192-.898a2.96 2.96 0 0 1-.902-2.18q0-.571.2-1.099.201-.527.602-.955z"
  }));
}
var IcFireFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFireFill));

export { IcFireFill as I };
